import { get } from "lodash";
import moment from "moment";
import { useRouter } from "next/router";
import React, { useEffect, useMemo, useState } from "react";

import Aux from "../../components/atom/children";

import Banner from "../../components/molecules/BannerTitle";

import Container from "../../components/atom/container/conatinerfull";
import Tablink from "../../components/molecules/Tab/leftTab";
// import pageLaoder from '../../../atom/loader/pageLaoder';

import DownloadFilter from "../../components/molecules/download/DownloadFilter";
import DownloadWithPagination from "../../components/molecules/download/DownloadWithPagination";
import {
  getYearsDropdown,
  searchFilter,
} from "../../components/molecules/download/config";
import DownlaodView from "../../components/molecules/download/index";
import { monthOptions, regEx } from "../../helper/constant";
import { DateRange } from "../../helper/validation";

// import { MFDownLaodHOC } from './MfHOC';

import Prelogin from "../../services/preLoginApi";
let api = new Prelogin();
let tabLinkMain = [
  // { name: "Mutual Funds", active: "mutualfund", url: "/Download/mutualfund/totalExpense" },
  // { name: "Portfolio Management Services", active: "PMS", url: "/Download/pms/Forms" },
];
let tabLink = [
  {
    name: "Document Disclosure",
    link: "disclosure-document",
    apiKey: "Disclosure_Document",
  },
  { name: "Presentations", link: "presentations", apiKey: "Presentations" },
  {
    name: "Monthly Communique",
    link: "monthly-communique",
    apiKey: "Monthly_Communique",
  },
  { name: "Document", link: "document", apiKey: "Document" },
  {
    name: "Leaflets/Brochures",
    link: "leaflets-brochures",
    apiKey: "Leaflet_Brochure",
  },
  { name: "Forms", link: "forms", apiKey: "Forms" },
  {
    name: "Regulatory Updates",
    link: "regulatory-updates",
    apiKey: "Regulatory_Updates",
  },
];

const getData = ({ allDownload, paramUrl, defaultActive }) => {
  let list = [];
  let activeT = "";
  let tabs = [];
  let keywiseData = {};

  if (allDownload !== null) {
    let checkExist = paramUrl in allDownload;
    if (checkExist) {
      let data = allDownload[paramUrl];
      list = data;
    }

    let namekeyAarry = [];
    let kyWiseData = [];

    allDownload["PMS"].map((curr, index) => {
      if (index === 0) {
        if (defaultActive) {
          activeT = curr.name;
        }
      }
      if (namekeyAarry.indexOf(curr.name) === -1) {
        namekeyAarry.push(curr.name);
        kyWiseData.push({ name: curr.name });
      }
    });

    tabs = kyWiseData;

    if (namekeyAarry.length > 0) {
      let keyData = {};
      namekeyAarry.forEach((ele, index) => {
        let data = [];
        allDownload["PMS"].map((curr, index) => {
          if (curr.name === ele) {
            data.push(curr);
          }
        });
        keyData[ele] = data;
      });
      keywiseData = keyData;
    }
  }
  return { list, activeT, tabs, keywiseData };
};

const getTabInfo = (pid, allDownload) => {
  let activeTabName = "";
  let parameterUrl = "";
  let downloads = get(allDownload, "PMS", []);

  const tabDownloadsAvail = tabLink.filter((tab) => {
    let name = get(tab, "name");
    let downloadsIndex = downloads.findIndex(
      (download) => download.name === name
    );
    return downloadsIndex > -1;
  });

  // tabDownloadsAvail.map((curr, index) => {
  for (let i = 0; i < tabDownloadsAvail.length; i++) {
    const index = i;
    const curr = tabDownloadsAvail[i];
    if (pid) {
      if (curr.link === pid) {
        parameterUrl = curr.apiKey;
        activeTabName = curr.name;
        break;
      } else if (index === 0) {
        parameterUrl = curr.apiKey;
        activeTabName = curr.name;
      }
    } else {
      if (index === 0) {
        parameterUrl = curr.apiKey;
        activeTabName = curr.name;
      }
    }
  }
  // });
  return { activeTabName, parameterUrl };
};

const getDownloadsWrtActiveTab = ({ activeTab, keyData }) => {
  let downloads = [];
  if (Object.keys(keyData).length > 0) {
    if (activeTab !== "Investor Charter") {
      let getData = keyData[activeTab];
      downloads = getData || [];
    } else {
      downloads = [];
    }
  }
  return downloads;
};

const Download = (props) => {
  let active = "PMS";
  let sebipdf = "/assets/pdf/Investor_Charter_PMS_Website_Upload.pdf";

  const router = useRouter();
  const { pid } = router.query;

  let allDownload = props.apiData;

  var startDateSearch = new Date();
  startDateSearch.setMonth(startDateSearch.getMonth() - 1);

  const { activeTabName, parameterUrl } = getTabInfo(pid, allDownload);
  const [paramUrl, setParamUrl] = useState(parameterUrl);

  const [defaultActive, setDefaultActive] = useState(true);

  const { list, activeT, tabs, keywiseData } = getData({
    allDownload,
    paramUrl,
    defaultActive,
  });

  
  const [tab, setTab] = useState(tabs);

  const [activeTab, setActiveTab] = useState(activeTabName); //active left tab

  const [apiData, setApiData] = useState([]);
  const [listData, setListData] = useState(list);

  const [state, setState] = useState({
    schameName: "",
    startDOB: startDateSearch,
    endDOB: new Date(),
  });
  let [keyData, setKeyData] = useState(keywiseData); //keyswiseData
  let [singleData, setSingleData] = useState(() => {
    const initial = getDownloadsWrtActiveTab({ activeTab, keyData }) || [];
    return initial;
  });
  const [optionShow, setOptionShow] = useState(null);
  const [error, setError] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);

  // adopt new download styles
  const [layoutView, setLayoutView] = useState("list");
  const [filterList, setFilterList] = useState([]);
  const [isFilter, setIsFilter] = useState(false);
  // DownloadFilter - state
  const [searchValue, setSearchValue] = useState("");

  const [selectedYear, setSelectedYear] = useState({
    label: "All",
    value: "All",
  });

  const [selectedMonth, setSelectedMonth] = useState({
    label: "All",
    value: "All",
  });

  const currentMonthIndex = monthOptions.findIndex(
    (item) => item.value === selectedMonth?.value
  );
  const month = currentMonthIndex === -1 ? "" : currentMonthIndex;
  const year = selectedYear.value === "All" ? "" : selectedYear.value;

  const yearsOptions = useMemo(() => {
    const lastListItem =
      singleData[singleData.length - 1]?.publishDate?.split("-");

    if (lastListItem?.length) {
      const lastItemDateYear = new Date(
        lastListItem[2],
        lastListItem[1],
        lastListItem[0]
      ).getFullYear();

      return getYearsDropdown(lastItemDateYear);
    }
    return [{ label: "All", value: "All" }];
  }, [singleData]);

  useEffect(() => {
    onDownloadFilterChange(searchValue, month, year);
  }, [searchValue, selectedMonth, selectedYear]);

  useEffect(() => {
    if (allDownload !== null) {
      let checkExist = paramUrl in allDownload;
      if (checkExist) {
        let data = allDownload[paramUrl];
        setListData(data);
      }
    }
  }, [paramUrl, allDownload]);

  useEffect(() => {
    if (allDownload !== null) {
      let namekeyAarry = [];
      let kyWiseData = [];

      allDownload["PMS"].map((curr, index) => {
        // if (index === 0) {
        //     if (defaultActive) {
        //         setActiveTab(curr.name)
        //     }

        // }
        if (namekeyAarry.indexOf(curr.name) === -1) {
          namekeyAarry.push(curr.name);
          kyWiseData.push({ name: curr.name });
        }
      });
      //   kyWiseData.push({
      //     name: "Investor Charter"
      //   })
      // setTab(kyWiseData.filter((item) => !excludeTabs.includes(item.name)));
      setTab(kyWiseData);

      if (namekeyAarry.length > 0) {
        let keyData = {};
        namekeyAarry.forEach((ele, index) => {
          let data = [];
          allDownload["PMS"].map((curr, index) => {
            if (curr.name === ele) {
              data.push(curr);
            }
          });
          keyData[ele] = data;
        });
        setKeyData(keyData);
      }
    }
  }, [allDownload]);

  useEffect(() => {
    if (Object.keys(keyData).length > 0) {
      if (activeTab !== "Investor Charter") {
        let getData = keyData[activeTab];
        setSingleData(getData);
      } else {
        setSingleData([]);
      }
    }
  }, [activeTab, keyData]);

  const changeHandler = (name, value) => {
    let allState = state;
    let validationRegx = /^[a-zA-Z0-9 ]*$/;
    if (name === "schameName") {
      if (validationRegx.test(value)) {
        allState[name] = value;
      }
    } else {
      allState[name] = value;
    }
    setState({ ...allState });
  };

  const validate = (name, value) => {
    let type = name;
    let errorMsg = { ...error };
    if (type === "schameName") {
      let alphabatesWithSpace = regEx.alphaNumericWithSingleSpace;
      if (!alphabatesWithSpace.test(value)) {
        errorMsg["schameNameError"] = "Please enter a valid name";
      } else {
        errorMsg["schameNameError"] = "";
      }
      setError(errorMsg);
    }
    if (type === "startDOB") {
      let strDate = DateRange(value);
      if (!strDate.res) {
        errorMsg["startDOBError"] = strDate.msg;
      } else {
        errorMsg["startDOBError"] = "";
      }
      setError(errorMsg);
    }
    if (type === "endDOB") {
      let endDate = DateRange(value);
      if (!endDate.res) {
        errorMsg["endDOBError"] = endDate.msg;
      } else {
        errorMsg["endDOBError"] = "";
      }
      setError(errorMsg);
    }
  };

  const gofilter = () => {
    let check = Formvalidate();
    if (check) {
      setBtnLoader(true);
      let { schameName, startDOB, endDOB } = state;
      let strtDate = moment(startDOB, "DD/MM/YYYY").format("DD/MM/YYYY");
      let endDate = moment(endDOB, "DD/MM/YYYY").format("DD/MM/YYYY");
      let payload = {
        api_name: "SearchDownloads",
        pagename: paramUrl,
        FilterTxt: schameName,
        SchCode: "",
        FromDate: endDate,
        ToDate: strtDate,
        from: "PMS",
      };

      api
        .SearchDownloads(payload)
        .then((res) => {
          let result = res.data.data;
          if (res.data.success) {
            setBtnLoader(false);
            setListData(result);
            setSingleData(result);
          } else {
            setBtnLoader(false);
            setListData(result);
            setSingleData(result);
          }
        })
        .catch((e) => {
          console.log("Error - PMS download search");
        });
    }
  };

  const dateFormat = (validDate) => {
    let data = new Date(validDate);
    let fullyear = data.getFullYear();
    let fullDate = data.getDate();
    let getMonth = data.getMonth() + 1;
    let pDate =
      fullDate.toString().length > 1
        ? fullDate.toString()
        : "0" + fullDate.toString();
    let pMonth =
      getMonth.toString().length > 1
        ? getMonth.toString()
        : "0" + getMonth.toString();

    return pDate + "/" + pMonth + "/" + fullyear.toString();
  };

  const Formvalidate = () => {
    let { schameName, startDOB, endDOB } = state;
    let stData = dateFormat(startDOB);
    let endData = dateFormat(endDOB);
    let strDate = DateRange(stData);
    let endDate = DateRange(endData);
    let alphabatesWithSpace = regEx.alphaNumericWithSingleSpace;
    let errorMsg = { ...error };
    let isflag = false;
    if (schameName === "") {
      errorMsg["schameNameError"] = "Please enter value";
    } else if (!alphabatesWithSpace.test(schameName)) {
      errorMsg["schameNameError"] = "Please enter a valid name";
    } else if (!strDate.res) {
      errorMsg["startDOBError"] = strDate.msg;
    } else if (!endDate.res) {
      errorMsg["endDOBError"] = endDate.msg;
    }
    //    else if (endData < stData) {
    //       errorMsg['endDOBError'] = "End date can not be less then start date."
    //   }
    else {
      isflag = true;
      errorMsg["schameNameError"] = "";
      errorMsg["startDOBError"] = "";
      errorMsg["endDOBError"] = "";
    }
    console.log(errorMsg, "errorMsg");
    setError(errorMsg);
    return isflag;
  };

  const tabClick = (data) => {
    let redire_url = "";
    tabLink.map((curr, index) => {
      if (curr.name === data) {
        router.push(`/download/${curr.link}`, undefined, { shallow: true });
        setActiveTab(curr.name);
        setParamUrl(curr.apiKey);
        setDefaultActive(false);
        setIsFilter(false);
        setFilterList([]);
        setSearchValue("");
        setSelectedYear({ label: "All", value: "All" });
        setSelectedMonth({
          label: "All",
          value: "All",
        });
      }
    });
  };

  const showDownloadPopup = (someId) => {
    setOptionShow(someId);
  };

  const hideDownloadPopup = () => {
    setOptionShow(null);
  };

  // download filter
  const onFilterChange = (name, value) => {
    if (name === "month") setSelectedMonth({ label: value, value });
    if (name === "year") setSelectedYear({ label: value, value });
  };

  const onSearchChange = (name, value) => {
    setSearchValue(value);
  };

  const onDownloadFilterChange = (searchValue, month, year) => {
    const searchObj = [
      { search: searchValue, key: "DocumentName" },
      { search: { month, year }, key: "publishDate", type: "date" },
    ];

    const filterData = searchFilter(singleData, searchObj);
    if (searchValue || month !== "" || year) {
      setIsFilter(true);
    }
    setFilterList(filterData);
  };

  return (
    <>
      <Aux>
        <Banner
          image="/assets/images/download/banner.svg"
          title="Downloads"
          imgClass="full_imge"
          class=""
          headingClass="bannerHeading"
          alt={"Motilal Oswal Mutual Fund"}
        />
        {/* <div className="col-md-12 padd0 text-center">
          <TabNav data={tabLinkMain} active={active} />
        </div> */}
      </Aux>
      <Container class="bodycolor_faq">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="row">
            <Tablink
              tabArray={tab}
              activeTab={activeTab}
              activeClick={tabClick}
            >
              {activeTab === "Investor Charter" ? (
                <>
                  <DownlaodView
                    date={""}
                    docName={"Investor Charter for PMS"}
                    file={sebipdf}
                    fileType={"pdf"}
                    isEditable={"0"}
                    optionShow={optionShow}
                    showDownloadPopup={showDownloadPopup}
                    hideDownloadPopup={hideDownloadPopup}
                  />
                </>
              ) : (
                <>
                  {/* {singleData.length > 0 ? (
                    <Searchicon
                      error={error}
                      state={state}
                      loader={btnLoader}
                      validate={validate}
                      btnClick={gofilter}
                      onChange={changeHandler}
                    />
                  ) : null} */}
                  {/* <Notfound msg="Data not available"/> */}

                  {/* {singleData.length > 0 ? (
                    <div className="row">
                      {singleData.map((curr, index) => {
                        return (
                          <DownlaodView
                            key={index}
                            date={curr.publishDate}
                            docName={curr.DocumentName}
                            file={curr.file}
                            fileType={curr.fileType}
                            optionShow={optionShow}
                            showDownloadPopup={showDownloadPopup}
                            hideDownloadPopup={hideDownloadPopup}
                          />
                        );
                      })}
                    </div>
                  ) : (
                    <div className="col-md-12  clearfix">
                      <Notfound class="text center" msg="Not  found" />
                    </div>
                  )} */}

                  <DownloadFilter
                    showLayoutView
                    isFilter={isFilter}
                    setLayoutView={setLayoutView}
                    layoutView={layoutView}
                    onFilterChange={onDownloadFilterChange}
                    searchValue={searchValue}
                    onSearchChange={onSearchChange}
                    selectedMonth={selectedMonth}
                    selectedYear={selectedYear}
                    changeHandler={onFilterChange}
                    yearsOptions={yearsOptions}
                  />
                  {/* <Notfound msg="Data not available"/> */}

                  <div className="row">
                    <DownloadWithPagination
                      data={singleData}
                      isFilter={isFilter}
                      filterList={filterList}
                      optionShow={optionShow}
                      showDownloadPopup={showDownloadPopup}
                      hideDownloadPopup={hideDownloadPopup}
                      layoutView={layoutView}
                      setLayoutView={setLayoutView}
                    />
                  </div>
                </>
              )}
            </Tablink>
          </div>
        </div>
      </Container>
    </>
  );
};

export async function getServerSideProps(req, res) {
  try {
    const { pid } = req.query;
    let Alldata = {};
    let payload = {
      api_name: "getDownloads",
    };
    let response = await api.download(payload);
    if (response.data.success) {
      Alldata = response.data.data;
    } else {
      Alldata = {};
    }
    return {
      props: {
        apiData: Alldata,
      },
    };
  } catch (e) {
    console.log("Error - Pms download getServerSideProps", e);
    return {
      props: {
        apiData: null,
      },
    };
  }
}

export default Download;
